export const isValidFileType = ({ allowedTypes, fileType }) => {
	if (
		allowedTypes &&
		allowedTypes.length > 0 &&
		allowedTypes.includes(fileType)
	) {
		return true;
	}
	if (!allowedTypes) {
		return true;
	}
	return false;
};
